import { css } from '@appd/uik';

export const BACKGROUND_SHAPES = (
  <svg
    className={css({
      position: 'absolute',
      left: 0,
      top: 250,
      pointerEvents: 'none',
      zIndex: -1,
    })}
    width="576"
    height="463"
    viewBox="0 0 576 463"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="22" cy="279" r="184" fill="url(#paint0_linear_0_1)" />
    <path d="M168 155.554L589.425 0.0552979V311.053L168 155.554Z" fill="url(#paint1_linear_0_1)" />
    <defs>
      <linearGradient
        id="paint0_linear_0_1"
        x1="62.5"
        y1="113.5"
        x2="170.545"
        y2="423.266"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="#D7C481" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_0_1"
        x1="639.002"
        y1="156.157"
        x2="296.449"
        y2="156.157"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E9ACCB" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
